import React from 'react';
import TransparentLogo from '../images/TransparentLogo.png';
import { UserAuthContext } from '../context/AuthContext';
import SetStatusBar from './SetStatusBar';
import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
import { Select, Option } from '@material-tailwind/react';
// import dayjs from 'dayjs';

const MenuHead = ({ status }) => {
  const { user } = UserAuthContext();
  // const [year, setYear] = React.useState(
  //   localStorage.getItem('declarationYear') || String(dayjs().year() - 1),
  // );

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // useEffect(() => {
  //   const decYear = localStorage.getItem('declarationYear');
  //   if (decYear) {
  //     setYear(decYear);
  //   }
  // }, []);

  // useEffect(() => {
  //   localStorage.setItem('declarationYear', year);
  // }, [year]);

  // const changeYear = (year) => {
  //   localStorage.setItem('declarationYear', year);
  // };

  const { t } = useTranslation();

  return (
    <div className="pr-5 bg-blue-50 text-blue-second border-b border-blue-gray-300 justify-end inline-flex items-center py-4 sm:py-0 w-full">
      <div className="flex-1 sm:block hidden">
        {!user || user?.email === 'taxreturn@meritsaccounting.ca' ? (
          <img src={TransparentLogo} alt="Logo" className="h-28" />
        ) : (
          <div className="flex items-center mx-8 h-28">
            <SetStatusBar status={status} />
          </div>
        )}
      </div>
      <div>
        <div
          className={`flex ${
            user ? 'visible' : 'invisible'
          } items-center text-sm`}
        >
          {user && user?.email}
        </div>
        <div className="text-xs">{user && user?.uid}</div>
        {/* <div className="m-4">
        <Select
          label={t('year')}
          color="blue-gray"
          value={year}
          onChange={(target) => changeYear(target)}
        >
          <Option value="2024">2024</Option>
          <Option value="2023">2023</Option>
          <Option value="2022">2022</Option>
        </Select>
      </div> */}
        <div className="m-4">
          <Select
            label={t('language')}
            color="blue-gray"
            value={i18n.language}
            onChange={(target) => changeLanguage(target)}
          >
            <Option value="pt">Português - BR</Option>
            <Option value="en">English - CA</Option>
          </Select>
        </div>
      </div>
    </div>
  );
};

export default MenuHead;
